import { Grid } from "@mui/material";
import React from "react";
import { Link } from "react-router-dom";

type Props = {
    data: any[];
    isLoading: boolean;
    orgId: string;
};

const OrganizationAnalystGroupsListCards: React.FC<
    React.PropsWithChildren<React.PropsWithChildren<Props>>
> = ({ data, isLoading, orgId }) => {
    return (
        <div style={{ flexGrow: 1 }}>
            <Grid container spacing={2}>
                {data.map((item) => (
                    <Grid item xs={12} sm={6} lg={4} key={item.id}>
                        <Link className="pendo-ignore"
                            to={`/admin/organizations/${orgId}/analyst-groups?id=${item.id}`}
                            style={{
                                background: "#FFFFFF",
                                boxShadow: "0px 1px 2px rgba(0, 0, 0, 0.07)",
                                borderRadius: 8,
                                minHeight: 175,
                                padding: 12,
                                display: "flex",
                                justifyContent: "space-between",
                                textDecoration: "none",
                                color: "#18181B",
                            }}
                        >
                            <div
                                style={{
                                    fontFamily: "Inter",
                                    fontStyle: "normal",
                                    fontWeight: 600,
                                    fontSize: 16,
                                    display: "flex",
                                    alignItems: "flex-start",
                                    textAlign: "left" as const,
                                    color: "#18181B",
                                }}
                            >
                                {item.groupName}
                            </div>
                            <div
                                style={{
                                    fontFamily: "Inter",
                                    fontStyle: "normal",
                                    fontWeight: "normal" as const,
                                    fontSize: 14,
                                    display: "flex",
                                    textAlign: "right" as const,
                                    color: "#A1A1AA",
                                    alignItems: "flex-end",
                                }}
                            >
                                {item.analystGroupMembers?.length} users
                            </div>
                        </Link>
                    </Grid>
                ))}
            </Grid>
        </div>
    );
};

export default OrganizationAnalystGroupsListCards;
